export default __webpack_public_path__ + "locales/lv/JavascriptSdk.json?hash=1fd1f17ee2ae2910d29e44fbdcf59267";